module.exports = __webpack_public_path__ + "media/1_3-47.838a4ef1.mp3";